import { GetterTree } from "vuex";
import { RootState } from "@service/store/types/RootState";
import { ServicesState } from "@service/store/types/ServicesState";
import { ServiceName } from "./types";

const getters: GetterTree<ServicesState, RootState> = {
    isValidServiceName: state => (serviceName: ServiceName) => {
        return state.validServiceNames.indexOf(serviceName) !== -1;
    },
    getServiceParam: (state, getters) => (serviceName: ServiceName, param: string) => {
        if (getters.isValidServiceName(serviceName)) {
            if(state.services[serviceName] && state.services[serviceName][param] !== undefined) {
                return state.services[serviceName][param];
            } else {
                if (state.serviceParams[serviceName] && state.serviceParams[serviceName][param]
                    && state.serviceParams[serviceName][param].defaultValue !== undefined) {
                        return state.serviceParams[serviceName][param].defaultValue;
                    }
                return undefined;
            }
        }
        return undefined;
    },
    serviceIsEnabled: (_, getters) => (serviceName: string, defaultValue = true) => {
        const isEnabled = getters["getServiceParam"](serviceName, "isEnabled");
        return typeof isEnabled === "boolean" ? isEnabled : defaultValue;
    },
    freshChatToken: (state) => (type: 'auth' | 'unauth' = 'unauth') => {
        return (state.services?.supportChat?.[type] as any)?.freshChatToken || null;
    },
    freshChatTags: (state) => (type: 'auth' | 'unauth' = 'unauth') => {
        return (state.services?.supportChat?.[type] as any)?.freshChatTags || [];
    },
    freshChatFireAfterLogin: (state) => (type: 'auth' | 'unauth' = 'unauth') => {
        return (state.services?.supportChat?.[type] as any)?.freshChatFireAfterLogin || null;
    },
    tabTitle: (state) => (tabName: string, lang: string): string => {
        return (state.services?.tabs?.titles?.[tabName]?.[lang]) || undefined
    }
};

export { getters }
